const sfs_stats = {
    init: () => {
  
  
        if ($('.shopify-section .sfs-stats')[0]) {
    
            $('.shopify-section .sfs-stats').each(function() {
                let section_id = $(this).data('section-id');
                let parent = `.sfs-stats[data-section-id="${section_id}"]`;
                
                const countersEl    = document.querySelector(`[sfs-stats-wrapper]`),
                      counters      = document.querySelectorAll(`${parent} [sfs-stats-number]`),
                      speed         = 100000;
                
                function animateCounters()
                {
                    counters.forEach(counter => {
                        const animate = () => {
                            const value = +counter.getAttribute('data-stat');
                            const data = +counter.innerText;
                            
                            const time = value / speed;
                            if(data < value)
                            {
                                counter.innerText = Math.ceil(data + time);
                                setTimeout(animate, 1);
                            }
                            else
                            {
                                counter.innerText = value;
                            }
                        }
                        animate();
                    });
                }

                const observer = new IntersectionObserver((entries, observer) => {
                    if (!entries[0].isIntersecting) return;
                    animateCounters();
                }, { threshold: 1 });

                observer.observe(countersEl);
    
            });

        }
  
  
    }
};
export default sfs_stats;